var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"buy-btn-comp",attrs:{"to":"#"}},[_c('span',{staticClass:"regular f-30 w__change"},[_vm._v(_vm._s(_vm.$fn.tr('შეძენა')))])])}
var staticRenderFns = []

export { render, staticRenderFns }